import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { http } from "@/lib/api";

export default function Rates() {
  const [rates, setRates] = useState([]);
  const [site, setSite] = useState(null);

  useEffect(() => {
    http.get("/rates").then((r) => setRates(r.data));
    http.get("/site").then((r) => setSite(r.data));
  }, []);

  return (
    <div className="pt-32 pb-24 relative" data-testid="rates-page">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">
        <div className="text-center mb-16">
          <div className="text-[10px] tracking-[0.35em] uppercase text-pink-blush mb-3">Services & Rates</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-champagne leading-tight">
            An investment in <span className="italic text-pink-hot">pleasure</span>
          </h1>
          <p className="max-w-2xl mx-auto mt-6 text-champagne/70">
            All rates are for the gentleman's time and companionship. Anything intimate shared between two consenting adults is incidental.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {rates.map((r, i) => (
            <motion.div
              key={r.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className={`glass-panel rounded-lg p-10 relative ${r.highlight ? "border-pink-hot/60 glow-pink" : ""}`}
              data-testid={`rate-card-${r.id}`}
            >
              {r.highlight && (
                <div className="absolute -top-3 left-10 text-[9px] tracking-[0.3em] uppercase bg-pink-hot text-white px-3 py-1 rounded-sm">
                  Most Requested
                </div>
              )}
              <div className="flex justify-between items-start mb-6">
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-rosegold mb-2">{r.duration}</div>
                  <div className="font-display italic text-4xl text-champagne">{r.title}</div>
                </div>
                <div className="text-right">
                  <div className="font-display text-5xl text-pink-hot leading-none">${r.price}</div>
                  <div className="text-xs text-champagne/60 mt-2">Deposit ${r.deposit}</div>
                </div>
              </div>
              <div className="divider-gold my-4" />
              <p className="text-sm text-champagne/80 leading-relaxed mb-6">{r.description}</p>
              <Link
                to={`/contact?rate=${r.id}`}
                className="inline-block px-6 py-3 bg-pink-hot text-white text-xs tracking-[0.3em] uppercase rounded-sm hover:bg-pink-glow glow-pink transition-all"
                data-testid={`book-rate-${r.id}`}
              >
                Request This
              </Link>
            </motion.div>
          ))}
        </div>

        <div className="mt-20 glass-panel rounded-lg p-10">
          <div className="text-[10px] tracking-[0.3em] uppercase text-pink-blush mb-3">Booking Policy</div>
          <h3 className="font-display text-3xl text-champagne mb-4">Graceful etiquette</h3>
          <p className="text-sm text-champagne/75 leading-relaxed max-w-3xl">{site?.booking_policy}</p>
          <div className="mt-6 grid sm:grid-cols-3 gap-4">
            {[
              "Non-refundable deposit secures your time",
              "Full discretion expected, always offered in return",
              "Screening required for first-time visitors",
            ].map((t, i) => (
              <div key={i} className="flex gap-3 items-start">
                <Check className="w-4 h-4 text-pink-hot mt-0.5 shrink-0" />
                <div className="text-sm text-champagne/80">{t}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
